var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import ApproveDetails from '~/components/collection-manage/collection-application/approve-details.vue';
import { CaseApplyManageService } from '~/services/business-service/case-apply-manage.service';
import { Emit, Prop } from 'vue-property-decorator';
import { SortService } from "~/utils/sort.service";
import { PageService } from '~/utils/page.service';
import { UserService } from '~/services/manage-service/user.service';
import DataBox from '~/components/common/data-box.vue';
var ApplicationDataAgree = /** @class */ (function (_super) {
    __extends(ApplicationDataAgree, _super);
    function ApplicationDataAgree() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applicationDataSet = [];
        _this.selectionList = [];
        _this.SearchModel = {
            flowType: 'CHECK_MATERIAL_APPLY',
            approvalStatus: 'APPROVED_COMPLETED'
        };
        _this.rowData = {};
        _this.dialog = {
            approveDetail: false
        };
        _this.loading = {
            state: false
        };
        return _this;
    }
    ApplicationDataAgree.prototype.refreshList = function () { };
    ApplicationDataAgree.prototype.close = function () { };
    ApplicationDataAgree.prototype.approveDetail = function (row) {
        this.dialog.approveDetail = true;
        this.rowData = row;
    };
    ApplicationDataAgree.prototype.refreshData = function () {
        var _this = this;
        this.SearchModel = Object.assign(this.SearchModel, this.applicationModel);
        this.SearchModel.applyDateStart = this.applicationModel.applyDate[0];
        this.SearchModel.applyDateEnd = this.applicationModel.applyDate[1];
        this.SearchModel.applyDate = '';
        this.caseApplyManageService.getProcessApproveMessage(this.SearchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.applicationDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        Dependencies(SortService)
    ], ApplicationDataAgree.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], ApplicationDataAgree.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], ApplicationDataAgree.prototype, "userService", void 0);
    __decorate([
        Dependencies(CaseApplyManageService)
    ], ApplicationDataAgree.prototype, "caseApplyManageService", void 0);
    __decorate([
        Emit('refreshList')
    ], ApplicationDataAgree.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], ApplicationDataAgree.prototype, "close", null);
    __decorate([
        Prop()
    ], ApplicationDataAgree.prototype, "applicationModel", void 0);
    ApplicationDataAgree = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                ApproveDetails: ApproveDetails
            },
        })
    ], ApplicationDataAgree);
    return ApplicationDataAgree;
}(Vue));
export default ApplicationDataAgree;
